var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemChannelPhotoFilled = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  role: "img"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  width: 18,
  height: 18,
  fill: "#FFF",
  rx: 2,
  transform: "translate(3 3)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  d: "M19.005 3C20.107 3 21 3.893 21 4.995v14.01A1.995 1.995 0 0 1 19.005 21H4.995A1.995 1.995 0 0 1 3 19.005V4.995C3 3.893 3.893 3 4.995 3Zm-2.867 3.857H7.862a1 1 0 0 0-1.005 1.005v8.276a1 1 0 0 0 1.005 1.005h8.276a1 1 0 0 0 1.005-1.005V7.862a1 1 0 0 0-1.005-1.005m-1.29 1.286c.558 0 1.01.448 1.01 1.008v5.698l-.007.11c-.054.505-.48.898-1.002.898H9.15l-.11-.006a1.006 1.006 0 0 1-.898-1.002V9.15l.006-.11c.054-.505.48-.898 1.002-.898Zm-4.057 3.452-1.685 2.167v1.445h5.778v-1.204l-1.445-1.685-.722.722.722 1.444zM13.93 9.43a.643.643 0 1 0 0 1.285.643.643 0 0 0 0-1.285"
}))));
export default SvgGemChannelPhotoFilled;